"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var utils_1 = require("./utils");
var NODE_SIZE_FACTOR = 0.03;
var NODE_SPACING_FACTOR = 0.005;
var CENTRE_REPULSION = -0.03;
var X_STRENGTH = 0.3;
var HALF = 0.5;
function nodePadding(svg) {
    return utils_1.boundingWidth(svg) * NODE_SPACING_FACTOR;
}
function nodeRadius(node, svg) {
    var radiusScale = node.multiplier === 0 ? 0.1 : node.multiplier;
    return radiusScale * utils_1.boundingWidth(svg) * NODE_SIZE_FACTOR;
}
exports.nodeRadius = nodeRadius;
function forceSimulation(svg) {
    var _a = utils_1.boundingDimensions(svg), height = _a.height, width = _a.width;
    var collisionForce = d3.forceCollide(function (d) {
        return nodeRadius(d, svg) + nodePadding(svg);
    });
    var xForce = d3.forceX(function (d) {
        return d.direction === 'from' ? width / 4 : 3 * width / 4;
    }).strength(X_STRENGTH);
    return d3.forceSimulation()
        .force("collision", collisionForce)
        .force("x", xForce)
        .force("antiCenter", d3.forceX(width * HALF).strength(CENTRE_REPULSION))
        .force("y", d3.forceY(height * HALF))
        .stop();
}
exports.forceSimulation = forceSimulation;
function tick(simulation) {
    simulation.alpha(1);
    for (var i = 0, n = Math.ceil(Math.log(simulation.alphaMin()) / Math.log(1 - simulation.alphaDecay())); i < n; ++i) {
        simulation.tick();
    }
}
exports.tick = tick;
//# sourceMappingURL=simulation.js.map